import { createRouter, createWebHistory } from 'vue-router'
import { session, loadSession } from '../stores/session'
import { routes as accountRoutes } from '../areas/account/routes'
import { routes as membershipRoutes } from '../areas/membership/routes'
import { routes as shopRoutes } from '../areas/shop/routes'
import { routes as quizModeRoutes } from '../areas/quiz-modes/routes'
import { routes as practiceRoutes } from '../areas/practice/routes'
import { routes as mapRoutes } from '../areas/map/routes'
import { routes as interviewRoutes } from '../areas/interview/routes'
import { routes as guideRoutes } from '../areas/guide/routes'

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, _from, saved) {
    if (saved) return saved
    if (to.hash) return { el: to.hash, top: 72 }
    return { top: 0 }
  },
  routes: [
    { path: '/', name: 'home', component: () => import('../views/HomeView.vue') },
    { path: '/login', name: 'login', component: () => import('../views/AuthRoute.vue') },
    { path: '/wrong', name: 'wrong', component: () => import('../views/WrongView.vue'), meta: { account: true } },
    { path: '/review', name: 'review', component: () => import('../views/ReviewView.vue'), meta: { account: true } },
    { path: '/history', name: 'history', component: () => import('../views/HistoryView.vue'), meta: { account: true } },
    ...accountRoutes,
    ...membershipRoutes,
    ...shopRoutes,
    ...practiceRoutes,
    ...quizModeRoutes,
    ...mapRoutes,
    ...interviewRoutes,
    ...guideRoutes,
    // Production screens without a rebuilt page yet; they render a placeholder under their production name.
    { path: '/guide-words', name: 'guide-words', component: () => import('../areas/guide/GuideWordsView.vue'), meta: { title: '导游词库' } },
    { path: '/video', name: 'video', component: () => import('../views/VideoView.vue'), meta: { title: '系统视频课' } },
  ],
})

router.beforeEach(async to => {
  if (!session.loaded) await loadSession()
  if (to.meta.account && !session.signedIn) return { name: 'login', query: { next: to.fullPath } }
})
